var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('vue-canvas-poster',{attrs:{"widthPixels":0,"painting":_vm.painting},on:{"success":_vm.success,"fail":_vm.fail}}),_c('div',{staticClass:"share_img"},[_c('img',{attrs:{"src":_vm.posterImg}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }